import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('ibanValidator', ibanValidator);

    /**
     * Validate Bank IBAN values
     *
     * @see https://github.com/arhs/iban.js
     * @author flzemke.btc
     * @ngInject
     */
    function ibanValidator() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                function ibanValidator(ngModelValue) {
                    if (!ngModelValue) {
                        ctrl.$setValidity('ibanValidator', true);
                        return ngModelValue;
                    }

                    return !!ngModelValue.match(
                        /[A-Za-z]{2}\d{2}(((\s?[A-Za-z0-9]{4}){7}\s?[A-Za-z0-9]{0,2})|((\s?[A-Za-z0-9]{4}){1,6}\s?[A-Za-z0-9]{0,3}))/
                    );
                }

                ctrl.$validators.ibanValidator = ibanValidator;
            }
        };
    }
})();
